/**
 * @generated SignedSource<<574d017abc18d5f0abee8425d16965f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type DashboardBlockPosition = "main" | "side" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ContentDashboardBlockPreviewContentFragment$data = {
  readonly contentUsages: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ContentUsageGridItemFragment">;
      };
    }>;
  } | null;
  readonly position: DashboardBlockPosition;
  readonly " $fragmentSpreads": FragmentRefs<"ContentDashboardBlockAdminDropdownFragment">;
  readonly " $fragmentType": "ContentDashboardBlockPreviewContentFragment";
};
export type ContentDashboardBlockPreviewContentFragment$key = {
  readonly " $data"?: ContentDashboardBlockPreviewContentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentDashboardBlockPreviewContentFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentDashboardBlockPreviewContentFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "position",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentUsageNodeConnection",
      "kind": "LinkedField",
      "name": "contentUsages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsageNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentUsage",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ContentUsageGridItemFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentDashboardBlockAdminDropdownFragment"
    }
  ],
  "type": "ContentDashboardBlock",
  "abstractKey": null
};

(node as any).hash = "baa1befa8319b0a183e82a7ebe4976ec";

export default node;
